var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconIllustrationBriefcase(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 45h-4c-4.411 0-8-3.589-8-8h2c0 3.309 2.691 6 6 6h4v2M28 45h24v-2H28zM64 45h-4v-2h4c3.309 0 6-2.691 6-6h2c0 4.411-3.589 8-8 8M50 21h-2v-6c0-.552-.449-1-1-1H33c-.551 0-1 .448-1 1v6h-2v-6c0-1.654 1.346-3 3-3h14c1.654 0 3 1.346 3 3v6M27 66h26v-2H27z",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADB1",
    d: "M27 22h26v-2H27zM35 41h10v-2H35z",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E97025",
    d: "M55 48h2v-5h-2zM23 48h2v-5h-2z",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADB1",
    d: "M55 33h2v-2h-2zM55 37h2v-2h-2zM55 53h2v-2h-2zM55 57h2v-2h-2zM23 33h2v-2h-2zM23 37h2v-2h-2zM23 53h2v-2h-2zM23 57h2v-2h-2zM31 18h18v-2H31zM39 37h2v-2h-2zM69 66H59v-2h10c.551 0 1-.448 1-1V23c0-.552-.449-1-1-1H59v-2h10c1.654 0 3 1.346 3 3v40c0 1.654-1.346 3-3 3M21 66H11c-1.654 0-3-1.346-3-3V23c0-1.654 1.346-3 3-3h10v2H11c-.551 0-1 .448-1 1v40c0 .552.449 1 1 1h10v2",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADB1",
    d: "M60 68h-8V48h2v18h4V48h2v20M28 68h-8V48h2v18h4V48h2v20M28 40h-2V20h-4v20h-2V18h8v22M60 40h-2V20h-4v20h-2V18h8v22",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 47h6v-6h-6v6zm-2 2h10V39H19v10zM53 47h6v-6h-6v6zm-2 2h10V39H51v10z",
    fill: "#E97025",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h80v80H0z"
  }))));
}

export default SvgIconIllustrationBriefcase;